import { render, staticRenderFns } from "./TransactionItem.vue?vue&type=template&id=8193da5e&scoped=true&"
import script from "./TransactionItem.vue?vue&type=script&lang=js&"
export * from "./TransactionItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionItem.vue?vue&type=style&index=0&id=8193da5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8193da5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
